import React, { Component } from "react";
/* eslint-disable import/no-webpack-loader-syntax */

import { Router, Switch, Redirect, Route } from "react-router-dom";
import RootView from "./pages/RootView";
import * as allUrls from "./router/allUrls";
import history from "./router/history";
import CustomRoute from "./router/CustomRoute";
import { observer } from "mobx-react";
import api from "./api/api";
import { FRONT_PREFIX, URL_INDEX } from "./consts/consts";
import Page404 from "./pages/Page404";
import storeGlobal from "./store/storeGlobal";

// 参考 http://react-china.org/t/webpack-bundle-loader-lazy-react-router/14464/2

const routes = Object.values(allUrls).map(item => item.options);

@observer
class App extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    storeGlobal.initOriginHeight();
    // storeGlobal.fetchAppConfig();
  }

  render() {
    return (
      <Router history={history}>
        <RootView>
          <Switch>
            <Redirect exact from="/" to={URL_INDEX} />
            <Redirect exact from={FRONT_PREFIX} to={URL_INDEX} />
            {/*<Route exact path="/404" component={lazy(PageNotFound)} />*/}
            {routes.map((route, i) => (
              <CustomRoute key={i} {...route} />
            ))}
            <Route path="/:any" component={Page404} />
          </Switch>
        </RootView>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js